var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_visible)?_c('div',{staticClass:"loader-ajax"},[_c('div',[_c('ion-spinner',{attrs:{"color":"primary"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }